// extracted by mini-css-extract-plugin
export default {"calendarLayout":"ResizableSidebarPageLayout_calendarLayout__1PSLp","sidebar":"ResizableSidebarPageLayout_sidebar__71o1D","content":"ResizableSidebarPageLayout_content__CDGu4"};